import { IFeatureMenuQuery } from 'generated/sanity-graphql';
import { RunningExperiments, useExperiments } from 'state/experiments';

interface IMenuVariant {
  variantName: string;
  menuVariantId: string;
}
export const useMenuVariant = (
  featureMenu: IFeatureMenuQuery['FeatureMenu']
): IMenuVariant | undefined => {
  const { variant } = useExperiments();
  const variants = featureMenu?.variants;

  if (!variants?.length) {
    return;
  }

  const foundMenuVariant = variants?.find(menuVariant => {
    const menuVariantKey = menuVariant?.key?.current;
    return !!menuVariantKey && variant(RunningExperiments.MenuVariant, menuVariantKey);
  });

  if (!foundMenuVariant) {
    return;
  }

  const variantName = foundMenuVariant.key?.current;
  const menuVariantId = foundMenuVariant.menuVariantReference?._id;

  if (!variantName || !menuVariantId) {
    return;
  }

  return {
    variantName,
    menuVariantId,
  };
};
